import store from 'store'

const el = '[data-content=HoldetsDonationer]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((HoldetsDonationerDOM)=>{
            const teamId = HoldetsDonationerDOM.dataset.teamid
            const donationFormUrl = HoldetsDonationerDOM.dataset.donationFormUrl
            
            store.commit('main/set_page_overlay_content_data',{ teamId, donationFormUrl })
        })
    }
}